import { render, staticRenderFns } from "./VCardInfo.vue?vue&type=template&id=02ca9bea&scoped=true"
import script from "./VCardInfo.vue?vue&type=script&lang=ts"
export * from "./VCardInfo.vue?vue&type=script&lang=ts"
import style0 from "./VCardInfo.vue?vue&type=style&index=0&id=02ca9bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ca9bea",
  null
  
)

export default component.exports